// // src/components/DesignDetailsSection.js
// import "./designDetailsSection.css";
// import React from 'react';

// function DesignDetailsSection() {
//   return (
//     <div className="design-details-section">
//       <div className="design-details-header">
//         <p className="precision-text">PRECISION</p>
//         <h2 className="details-main-title">Design is in the Details</h2>
//         <p className="details-subtitle">
//           Elevating Spaces with Thoughtful Finishes and Perfect Touches
//         </p>
//       </div>
//       <div className="details-bar">
//         <p className="details-bar-title">Designs</p>
//       </div>
//       <div className="design-details-images">
//         <img
//           src="images\Design 1.png"
//           alt="Modern Bathroom 1"
//           className="details-img1"
//         />
//         <img
//           src="images\Design 2.png"
//           alt="Modern Bathroom 2"
//           className="details-img2"
//         />
//         <img
//           src="images\Design 3.png"
//           alt="Modern Bathroom 2"
//           className="details-img2"
//         />
//         <img
//           src="images\Design 4.png"
//           alt="Modern Bathroom 2"
//           className="details-img2"
//         />
//         <img
//           src="images\Design 5.png"
//           alt="Modern Bathroom 2"
//           className="details-img2"
//         />
//         <img
//           src="images\Design 6.png"
//           alt="Modern Bathroom 2"
//           className="details-img2"
//         />
//       </div>
//     </div>
//   );
// }

// export default DesignDetailsSection;


// src/components/DesignDetailsSection.js
import "./designDetailsSection.css";
import React from 'react';

function DesignDetailsSection() {
  return (
    <div className="design-details-section">
      <div className="design-details-header">
        <p className="precision-text">PRECISION</p>
        <h2 className="details-main-title">Design is in the Details</h2>
        <p className="details-subtitle">
          Elevating Spaces with Thoughtful Finishes and Perfect Touches
        </p>
      </div>

      <div className="details-bar">
        <p className="details-bar-title">Designs</p>
      </div>

      {/* <div className="design-details-layout">
        <div className="left-large-image">
          <img
            src="images/Design 1.png"
            alt="Modern Bathroom Main"
            className="main-img"
          />
        </div>
        <div className="right-image-grid">
          <img src="images/Design 2.png" alt="Design 2" className="small-img img2" />
          <img src="images/Design 3.png" alt="Design 3" className="small-img img3" />
          <img src="images/Design 4.png" alt="Design 4" className="small-img img4" />
          <img src="images/Design 5.png" alt="Design 5" className="small-img img5" />
          <img src="images/Design 6.png" alt="Design 6" className="small-img img6" />
        </div>
      </div> */}


{/* 
      <div class="gallery">
        <div class="featured">
          <img src="images/Design 1.png" alt="Featured Image"></img>
        </div>
        <div class="masonry">
          <img src="images/Design 2.png" alt="Gallery Image 2" ></img>
          <img src="images/Design 3.png" alt="Gallery Image 3" ></img>
          <img src="images/Design 4.png" alt="Gallery Image 4" ></img>
          <img src="images/Design 5.png" alt="Gallery Image 5" className="img5"></img>
          <img src="images/Design 6.png" alt="Gallery Image 6" className="img6"></img>
        </div>
      </div> */}


      <div className="gallery">
      <div className="featured">
        <img src="images/Design 1.png" alt="Featured" className="imgcheck1"/>
      </div>
      {/* <div className="masonry">
        <img src="images/Design 2.png" alt="Gallery 2"className="imgcheck2" />
        <img src="images/Design 3.png" alt="Gallery 3" className="imgcheck3"/>
        <img src="images/Design 4.png" alt="Gallery 4" className="imgcheck4"/>
        <img src="images/Design 5.png" alt="Gallery 5" className="imgcheck5"/>
        <img src="images/Design 6.png" alt="Gallery 6" className="imgcheck6"/>
      </div> */}

<div className="masonry">
  <img src="images/Design 2.png" alt="Gallery 2" className="imgcheck2" />
  <img src="images/Design 3.png" alt="Gallery 3" className="imgcheck3" />
  <img src="images/Design 4.png" alt="Gallery 4" className="imgcheck4" />
  
  <div className="bottom-stack">
    <img src="images/Design 5.png" alt="Gallery 5" className="imgcheck5" />
    <img src="images/Design 6.png" alt="Gallery 6" className="imgcheck6" />
  </div>
</div>
    </div>




    </div>
  );
}

export default DesignDetailsSection;
